<template>
    <div class="filterSlider">
        <div class="filterSlider__box">
            <img :src="Filterbanner" alt="">
        </div>
    </div>
</template>

<script>
    import filterbanner from '../../assets/images/filterbanner.png'
export default {
    data() {
        return {
            Filterbanner : filterbanner,
        }
    },
}
</script>

<style scoped>

.filterSlider__box {
    padding: 1rem ;

}

.filterSlider__box img {
    width: 100%;
}

</style>